import { GridFilterModel } from '@mui/x-data-grid-pro';
import { EmployeeReceiptsTableViewModel, ReceiptsTableViewModel } from '../viewModel';
import { TableManagerViewModel } from '../../../../lib/components/compound/table';
import { ReceiptsViewModel } from '../../../../viewModels/receipts';
import { reaction } from 'mobx';
import CompanyStore from '../../../../stores/companyStore';
import { ReceiptsRowViewModel } from '../row/viewModel';
import { ReceiptListStore, ReceiptsFilterModel } from '../../../../stores/receipts/list';
import Util from '../../../../misc/util';
import { ReceiptStatusEnum } from '@pxtra-client-lib-legacy/gen';
import { ListStoreFilterModel } from '../../../../stores/base/ListStore';

export class ReceiptsTableManagerViewModel extends TableManagerViewModel<
  ReceiptsViewModel,
  ReceiptsRowViewModel,
  ReceiptsTableViewModel
> {
  protected date?: Date;

  constructor(
    tableViewModel: ReceiptsTableViewModel,
    listStore: ReceiptListStore,
    companyStore: CompanyStore
  ) {
    // @ts-expect-error Types of store implementations are incompatible but work at runtime
    super(tableViewModel, listStore);
    this.filterDelay = 500;
    reaction(
      () => companyStore.company,
      () => {
        this.clear();
        this.listStore.getPage();
      }
    );
    this.tableViewModel.actionDialog.onConfirm.subscribe(async (items) => {
      if (items && items.length > 0) {
        this.clearSelection();
        this.refresh(true);
      }
    });
  }

  public setDateFilter(date: Date) {
    this.date = date;
    this.filterModelChanged();
  }

  public setStatusFilter(status?: ReceiptStatusEnum) {
    if (status) {
      this.tableApiRef?.upsertFilterItem({
        id: 'base-status',
        columnField: 'status',
        value: status
      });
    } else {
      this.tableApiRef?.deleteFilterItem({
        id: 'base-status',
        columnField: 'status'
      });
    }
  }

  protected get dateMonthRange() {
    if (!this.date) return {};

    const dateAfter = Util.getFirstDayOfMonth(this.date);
    const dateBefore = Util.getLastDayOfMonth(this.date);

    return {
      dateAfter: Util.getDateString(dateAfter),
      dateBefore: Util.getDateString(dateBefore)
    };
  }

  mapMuiFilterModel(
    model: GridFilterModel
  ): ListStoreFilterModel<ReceiptsFilterModel, ReceiptsViewModel> {
    return {
      backend: {
        benefit: this.getFilterString(model, 'benefit'),
        employeeName: this.getFilterString(model, 'employeeName'),
        note: this.getFilterString(model, 'note'),
        status: this.getFilterString(model, 'status'),
        search: model.quickFilterValues?.at(0),
        ...this.dateMonthRange
      }
    };
  }

  private get translate() {
    return this.tableViewModel.translate;
  }
}

export class EmployeeReceiptsTableManagerViewModel extends ReceiptsTableManagerViewModel {
  constructor(
    tableViewModel: EmployeeReceiptsTableViewModel,
    listStore: ReceiptListStore,
    companyStore: CompanyStore,
    private employeeId: string
  ) {
    super(tableViewModel, listStore, companyStore);
    this.listStore.setFilter({ backend: { employee: this.employeeId } });
  }

  mapMuiFilterModel(
    model: GridFilterModel
  ): ListStoreFilterModel<ReceiptsFilterModel, ReceiptsViewModel> {
    return {
      backend: {
        benefit: this.getFilterString(model, 'benefit'),
        employeeName: undefined,
        employee: this.employeeId,
        note: this.getFilterString(model, 'note'),
        status: this.getFilterString(model, 'status'),
        search: model.quickFilterValues?.at(0),
        ...this.dateMonthRange
      }
    };
  }
}
